<template>
<!-- INCOMPLETISIMO -->
<!-- OJO!!! Para cualquier cambio revisar si se puede mostrar en la página externa -->
<div v-if="curso && actividad && participaciones">
<h3>Actividad: {{ actividad.nombre }}</h3>

<div class="row mb-3">
<b-dropdown id="dropdown-periodo" :text="'Periodo: ' + periodoTexto(periodoSeleccionado)">
  <b-dropdown-item v-for="p in actividad.periodos" :key="p" @click="cambiarPeriodo(p)">{{ periodoTexto(p) }}</b-dropdown-item>
</b-dropdown>
</div>

<div id="actividad-detalle" v-if="! externo">
<table class="table table-striped table-bordered table-hover">
<thead>
<tr><th>Grupo</th><th>Horas</th><th>Niveles</th><th>Cuota</th><th>Comisión</th></tr>
</thead>
<tbody>
<tr v-for="g in actividad.grupos" :key="g.id" class="fila-grupo">
<td><span class="datos-grupo">{{ g.nombre }}</span></td>
<td><span v-html="horasTexto(g.horas)"></span></td>
<td><span v-html="nivelesTexto(g.niveles)"></span></td>
<td v-html="mostrarCuotas(g.cuotas)"></td>
<td v-html="mostrarComisiones(g.comisiones)"></td>
</tr>
</tbody>
</table>
</div>

<div class="mb-3" v-if="! externo">
<a :href="actividad.url_externa">Enlace para acceso externo</a>
</div>

<div class="row">
Grupos:
    <b-form-group>
      <b-form-radio-group
        id="seleccion-grupo"
        v-model="grupoSeleccionado"
        buttons
        button-variant="outline-secondary"
        name="estado-grupo"
      >
        <b-form-radio value="todos">Todos</b-form-radio>
        <b-form-radio v-for="g in actividad.grupos" :key="g.id" :value="g.id">{{ g.nombre }}</b-form-radio>
      </b-form-radio-group>
    </b-form-group>
</div>

<div class="row">
Horas:
    <b-form-group>
      <b-form-radio-group
        id="seleccion-hora"
        v-model="horaSeleccionada"
        buttons
        button-variant="outline-secondary"
        name="seleccion-hora"
      >
        <b-form-radio value="todas">Todas</b-form-radio>
        <b-form-radio v-for="h in horasActividad()" :key="h" :value="h">{{ horasTexto([h]) }}</b-form-radio>
      </b-form-radio-group>
    </b-form-group>
</div>

<b-button @click="visibilidadContacto()" class="mb-3">Mostrar email/teléfono y nacimiento</b-button>

<div>
<table class="table table-striped table-bordered table-hover" id="tabla-participantes">
<thead>
<tr><th>Nombre</th><th>Apellidos</th><th>Nivel</th><th>Grupo</th><th>Horas</th><th>Nacimiento</th><th>Teléfono</th><th>Email</th><th>id_grupo</th><th>id_horas</th></tr>
</thead>
<tbody>
<tr v-for="p in participaciones" :key="p.id" class="fila-participante" @click="abrirFamilia(p.persona.id_familia)" @click.middle="abrirFamiliaTab(p.persona.id_familia)">
<td>{{ p.persona.nombre }}</td>
<td>{{ p.persona.apellidos }}</td>
<td :data-sort="p.persona.nivel.id_nivel">{{ nivelesTexto(p.persona.nivel.id_nivel) }}</td>
<td>{{ nombreGrupo(p.id_grupo) }}</td>
<td><span v-html="horasTexto(p.horas, ', ')"></span></td>
<td>{{ p.persona.nacimiento }}</td>
<td>{{ p.contacto.telefono }}</td>
<td>{{ p.contacto.email }}</td>
<td>{{ p.id_grupo }}</td>
<td>{{ p.horas }}</td>
</tr>
</tbody>
</table>
</div>

<div>
<h3 class="mt-3">Resumen de cuotas</h3>
<table class="table table-striped table-bordered table-hover" id="tabla-resumen">
<thead>
<tr>
<th>Grupos</th>
<th>Participantes</th>
<th v-if="! externo">Cuota</th>
<th v-if="! externo">Total cuotas</th>
<th>Comisión</th>
<th>Total comisión</th>
</tr>
</thead>
<tbody>
<tr v-for="(bloque, idx) in resumenCuotas()" :key="idx">
<td class="align-middle">{{ bloque.nombre }}</td>
<td class="align-middle">{{ bloque.participantes }}</td>
<td class="align-middle" v-if="! externo">{{ bloque.cuota }}</td>
<td class="align-middle" v-if="! externo">{{ bloque.suma_cuotas }}</td>
<td class="align-middle">{{ bloque.comision }}</td>
<td class="align-middle">{{ bloque.suma_comisiones }}</td>
</tr>
<!--
<tr>
<td class="align-middle">Total</td>
<td class="align-middle">{{ resumen.totales.participantes }}</td>
<td class="align-middle">-</td>
<td class="align-middle">{{ resumen.totales.total_cuotas }}</td>
<td class="align-middle">-</td>
<td class="align-middle">{{ resumen.totales.total_comision }}</td>
</tr>
-->
</tbody>
</table>
</div>

  </div>
</template>

<script>

import { api } from '../api/api.js';
import { obtenerCursoActivo, obtenerPeriodoActual } from '../curso.js';
import * as utils from '../utils.js';

import $ from 'jquery';
import 'pdfmake';
//import 'pdfmake/build/vfs_fonts';
// eslint-disable-next-line no-unused-vars
import jszip from 'jszip';
import 'datatables.net-bs4';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
//require('../../../css/datatables.min.css')

export default {
	props: [
		'externo',
		'idActividad',
		'idPeriodo',
		'token',
	],
	name: 'AdminActividad',
	data () {
		return {
			actividad: null,
			participaciones: null,
			curso: null,
			dataTable: null,
			periodoSeleccionado: null,
			grupoSeleccionado: null,
			horaSeleccionada: null,
		}
	},
	created () {
		this.curso = obtenerCursoActivo();
		this.obtenerActividad(this.idActividad);
		let periodoInicial;
		if (this.idPeriodo) {
			periodoInicial = this.idPeriodo;
		} else {
			// TODO: Verificar si el período actual coincide con los períodos de la actividad
			periodoInicial = obtenerPeriodoActual().id_periodo;
		}
		this.periodoSeleccionado = periodoInicial;
		this.grupoSeleccionado = 'todos';
		this.horaSeleccionada = 'todas';
	},
	watch: {
		periodoSeleccionado: function(idPeriodo) {
			this.obtenerParticipaciones(this.idActividad, idPeriodo);
		},
		grupoSeleccionado: function(grupo) {
			if (! this.dataTable) {
				return;
			}
			if (grupo == 'todos') {
				this.dataTable.column(8).search('').draw();
			} else {
				this.dataTable.column(8).search('^' + grupo + '$', true).draw();
			}
		},
		horaSeleccionada: function(hora) {
			if (! this.dataTable) {
				return;
			}
			if (hora == 'todas') {
				this.dataTable.column(9).search('').draw();
			} else {
				this.dataTable.column(9).search(hora, true).draw();
			}
		}
	},
	methods: {
		cambiarPeriodo(idPeriodo) {
			// Vaciar la lista de participaciones y entonces destruir dataTable
			// parecer ser la única manera de reiniciar la tabla correctamente
			this.participaciones = [];
			this.dataTable.destroy();
			if (this.externo) {
				this.$router.push(`/externo/actividad/${this.token}/${this.idActividad}/${idPeriodo}`);
			} else {
				this.$router.push(`/admin/actividad/${this.idActividad}/${idPeriodo}`);
			}
			this.periodoSeleccionado = idPeriodo;
		},
		obtenerActividad(idActividad) {
			const auth = this.externo ? `Activity ${this.token}` : null;
			api(`/actividades/${this.curso.id_curso}/${idActividad}`, 'GET', null, auth)
                .then((data) => {
					this.actividad = data.resultado;
                })
                .catch((error) => {
                    console.log(error);
                    //this.mensaje_error = error;
                });
		},
		obtenerParticipaciones(idActividad, idPeriodo) {
			const auth = this.externo ? `Activity ${this.token}` : null;
			api(`/actividades/${this.curso.id_curso}/${idActividad}/participaciones/${idPeriodo}`, 'GET', null, auth)
                .then((data) => {
					this.participaciones = data.resultado;
					this.$nextTick(() => {
						this.prepararTabla();
					});
                })
                .catch((error) => {
                    console.log(error);
                    //this.mensaje_error = error;
                });
		},
		resumenCuotas() {
			const bloques = {};
			for (const g of this.actividad.grupos) {
				for (const part of this.participaciones) {
					if (part.id_grupo == g.id) {
						let clave;
						let num_horas = 0;
						if ('horas' in part) {
							num_horas = part.horas.length;
							clave = `${g.id}_${part.cuota}_${num_horas}`;
						} else {
							clave = `${g.id}_${part.cuota}`;
						}
						if (! (clave in bloques)) {
							bloques[clave] = {
								participantes: 0,
								cuota: part.cuota,
								comision: part.comision,
							}
							if (num_horas > 0) {
								bloques[clave].nombre = `${g.nombre} (${num_horas} horas)`;
							} else {
								bloques[clave].nombre = g.nombre;
							}
						}
						bloques[clave].participantes += 1;
					}
				}
			}
			let total_cuotas = 0;
			let total_comisiones = 0;
			let total_participantes = 0;
			const resumen = [];
			for (const bloque of Object.values(bloques)) {
				bloque.suma_cuotas = bloque.cuota * bloque.participantes;
				bloque.suma_comisiones = bloque.comision * bloque.participantes;
				total_cuotas += bloque.suma_cuotas;
				total_comisiones += bloque.suma_comisiones;
				total_participantes += bloque.participantes;
				resumen.push(bloque);
			}

			resumen.sort((a, b) => { return a.nombre.localeCompare(b.nombre) });
			resumen.push({
				nombre: 'Total',
				cuota: '-',
				comision: '-',
				suma_cuotas: total_cuotas,
				suma_comisiones: total_comisiones,
				participantes: total_participantes,
			});
			return resumen;
		},
		horasActividad() {
			let horasActividad = [];
			for (const g of this.actividad.grupos) {
				if (g.horas) {
					horasActividad = horasActividad.concat(g.horas);
				}
			}
			return horasActividad;
		},
		nombreGrupo(id_grupo) {
			for (const g of this.actividad.grupos) {
				if (g.id == id_grupo) {
					return g.nombre;
				}
			}
			return '<n/a>';
		},
		horasTexto(listaHoras, separador='<br />') {
			const horas = utils.convertirHoras(listaHoras);
			if (horas) {
				return horas.join(separador);
			} else {
				return '';
			}
		},
		nivelesTexto(listaNiveles, separador='<br />') {
			const niveles = utils.convertirNiveles(listaNiveles);
			return niveles.join(separador);
		},
		visibilidadContacto() {
			const columnaNacimiento = this.dataTable.column(5);
			const columnaTelefono = this.dataTable.column(6);
			const columnaEmail = this.dataTable.column(7);
			columnaNacimiento.visible(!columnaTelefono.visible());
			columnaTelefono.visible(!columnaTelefono.visible());
			columnaEmail.visible(!columnaEmail.visible());
		},
		// FIXME: este lo tengo en otros módulos, unificar con el de arriba
		//mostrarHoras(listaHoras) {
		//	const convertidas = convertirHoras(listaHoras);
		//	return convertidas.join('<br />');
		//},
		// FIXME: copiado de SociosHorario
		mostrarNiveles(listaNiveles) {
			const gruposNiveles = [];
			let inicio, fin, seccion, siguienteNivel;
			for (const id_nivel of listaNiveles) {
				let n;
				for (n of this.niveles) {
					if (n.id_nivel == id_nivel) {
						break;
					}
				}
				if (n.seccion == seccion && n.id_nivel == siguienteNivel) {
					fin = n.nombre;
					siguienteNivel = n.siguiente;
				} else {
					if (inicio) {
						gruposNiveles.push([inicio, fin]);
					}
					inicio = n.nombre;
					fin = n.nombre;
					seccion = n.seccion;
					siguienteNivel = n.siguiente;
				}
			}
			gruposNiveles.push([inicio, fin]);

			const nivelesTexto = [];
			for (let [inicio, fin] of gruposNiveles) {
				inicio = inicio.replace(' ', '&nbsp;');
				fin = fin.replace(' ', '&nbsp;');
				if (inicio == fin) {
					nivelesTexto.push(inicio);
				} else {
					nivelesTexto.push(`${inicio}<br />↓<br />${fin}`);
				}
			}
			return nivelesTexto.join('<br />');
		},
		// FIXME: copiado de SociosHorario
		mostrarCuotas(cuotas) {
			let cuotasTexto = '';
			const adscripcionesDistintas = Object.keys(cuotas).length;
			for (const adscripcion of ['socio', 'exsocio']) {
				if (! (adscripcion in cuotas)) {
					continue;
				}
				if (adscripcionesDistintas > 1) {
					cuotasTexto += '<i>' + adscripcion + ':</i><br />';
				}
				let periodos = Object.keys(cuotas[adscripcion]);
				periodos.sort();
				for (const periodo of periodos) {
					let listaHoras = Object.keys(cuotas[adscripcion][periodo]);
					listaHoras.sort((a, b) => { parseInt(a) < parseInt(b) });
					for (const hora of listaHoras) {
						if (periodo != 'base') {
							const mesTxt = periodo.substring(4, 6) + '/' + periodo.substring(0, 4);
							cuotasTexto += mesTxt + ' - ';
						}
						if (hora == '0' || listaHoras.length == 1) {
							cuotasTexto += cuotas[adscripcion][periodo][hora] + '&nbsp;€<br />';
						} else {
							cuotasTexto += hora + 'h - ' + cuotas[adscripcion][periodo][hora] + '&nbsp;€<br />';
						}
					}
				}
			}
			return cuotasTexto;
		},
		mostrarComisiones(comisiones) {
			if (! comisiones) {
				return '';
			}
			let comisionesTexto = '';
			let listaHoras = Object.keys(comisiones);
			listaHoras.sort((a, b) => { parseInt(a) < parseInt(b) });
			for (const hora of listaHoras) {
				if (listaHoras.length > 1) {
					comisionesTexto += hora + 'h - ' + comisiones[hora] + '&nbsp;€<br />';
				} else {
					comisionesTexto += comisiones[hora] + '&nbsp;€<br />';
				}
			}
			return comisionesTexto;
		},
		periodoTexto(periodo) {
			return utils.convertirPeriodo(periodo);
		},
		//nombreNivel(id_nivel) {
		//}
		abrirFamilia(id_familia) {
			if (! this.externo) {
				this.$router.push('/admin/familia/' + id_familia);
			}
		},
		abrirFamiliaTab(id_familia) {
			if (! this.externo) {
				window.open('/admin/familia/' + id_familia);
			}
		},
		prepararTabla() {
			if (this.dataTable) {
				//this.dataTable.clear();
				//this.participaciones = [];
				//this.dataTable.destroy();
				//this.dataTable.row().invalidate();
				//this.dataTable.rows().invalidate();
				//this.dataTable.fnClearTable();
				//this.dataTable.clear();
				//this.dataTable.rows().invalidate();
				//this.dataTable.clear();
				//this.dataTable.draw();
				//return;
			}
			this.dataTable = $('#tabla-participantes').DataTable({
				"paging": false,
				"columnDefs": [
					{
						"targets": [ 5, 6, 7, 8, 9 ],
						"visible": false,
					},
					{
						"targets": [ 0, 1, 2, 4, 8, 9 ],
						"class": "noVis",
					}
				],
				//"dom": "Bfrtip",
				"dom": "<'row'<'col-12 col-md-6'B><'col-12 col-md-6'l>>" +
						"<'row'<'col-12 col-md-12'i>>" +
						"<'row'<'col-12'tr>>",
				"buttons": [
					{
						extend: 'csvHtml5',
						text: 'CSV / Excel',
						exportOptions: {
							columns: ':visible',
						}
					},
					{
						extend: 'excelHtml5',
						exportOptions: {
							columns: ':visible',
						}
					},
					//{
					//	extend: 'pdfHtml5',
					//	exportOptions: {
					//		columns: ':visible',
					//	}
					//},
					{
						extend: 'print',
						text: 'Imprimir',
						exportOptions: {
							columns: ':visible',
						}
					},
					// FIXME: Esto no funciona, por alguna combinación entre datatable, vue y bootstrap
					//{
					//	extend: 'colvis',
					//	text: 'Escoger columnas',
					//	columns: ':not(.noVis)'
					//}
				],
				"language": {
					"lengthMenu": "_MENU_ filas",
					"info": "_TOTAL_ filas (mostrando _START_-_END_)",
					"infoEmpty": "0 filas",
					"infoFiltered": "", // _MAX_
					"zeroRecords": "No hay filas que mostrar",
					"emptyTable": "Sin datos en la tabla",
					"paginate": {
						"first": "&lt;&lt;",
						"previous": "&lt;",
						"next": "&gt;",
						"las": "&gt;&gt;",
					},
				},
			});
		},
	}
}
</script>
